import Cookies from 'js-cookie'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import router from 'router'
import store from 'store'
window.Cookies = Cookies;
const TokenKey = 'satoken'
const CookieKey = 'TGC'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    let millisecond = new Date().getTime()
    let expiresTime = new Date(millisecond + 60 * 1000 * 60 * 5)
    return Cookies.set(TokenKey, token, {
        expires: expiresTime
    })
}

export function setCookie(value) {
    return Cookies.set(CookieKey, value)
}

export function getCookie() {
    return Cookies.get(CookieKey)
}

export function removeToken() {
    Cookies.remove(CookieKey);
    return Cookies.remove(TokenKey)
}

const customerUrl = ['/login', '/Home', '/home', '/gmv', '/gmvStatistics', '/warehouseMoney', '/purchase', '/diy', '/myOrder', "/blankPage", '/userSetup', '/wms', '/fenxiaoExtendAdvance/invoiceRequest'] //普通用户可以访问的地址，其他地址全部拦截

/* 当普通用户登录后，由于特殊原因，普通用户访问到管理员权限时，自动跳出，不继续访问  */
export function accessDenied(str, next) {
    let roles = store.getters.roles
    if (roles.length == 1 && roles.includes(1)) {
        let i = urlValid(str)
        if (!i) {
            router.push({ path: '/' })
            NProgress.done()
        }
    }
}

export function urlValid(str) {
    let i = 0
    customerUrl.forEach((item => {
        let reg = RegExp(item, 'g')
        if (reg.test(str)) {
            i = 1
        }
    }))
    return i
}

/**
 * 判断当时是否为普通用户
 */
export function currentNormalUser() {
    let roles = store.getters.roles
    return roles.length == 1 && roles.includes(1) ? true : false
}


/**
 * 判断当前用户是否为业务员
 */
export function currentSalesman() {
    let salesman = store.getters.salesman
    return salesman == 1 ? true : false
}

/**
 * 判断当前用户是否为采购员
 */
 export function currentPurchase() {
    return store.getters.purchase
}